// Author Lin
// Date 2021-05-16 19:04:44

import * as model from "@/model/sithMes/inventory/SithMesInventoryAbnormalArrivalProcessModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.SithMesInventoryAbnormalArrivalProcess(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_SITHMES_INVENTORY_URL,
        callbackApi: process.env.VUE_APP_SITHMES_INVENTORY_URL + '/sithMesInventoryAbnormalArrivalProcess/workflow/complete-feedback',
        processDefinitionKey: "inventory_abnormal_arrival",
        processBusinessData: Object
    })
    .withMutations({
        setProcessBusinessData(state, data) {
            state.processBusinessData = data
        }
    })
    .buildStore()
